export function addUtmParameters(_url?: string) {
	if (!_url) {
		return;
	}
	const url = new URL(_url);

	const searchParams = url.searchParams;

	const utmSource = searchParams.get("utm_source");

	//ensure lowerCase & always override utm
	if (utmSource === "Nutzy" || utmSource !== "nutzy") {
		searchParams.delete("utm_source");
		searchParams.append("utm_source", "nutzy");
	} else if (!utmSource) {
		searchParams.append("utm_source", "nutzy");
	}
	const utmMedium = searchParams.get("utm_medium");
	if (!utmMedium) {
		searchParams.append("utm_medium", "referral");
	}

	const new_url = new URL(`${url.origin}${url.pathname}?${searchParams}`);

	return new_url.href;
}
